import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { getApiErrorMessage, isAuthenticated, login, startFanvueSignupOAuth } from '../api'
import { defaultPathForRole, getRealm, getStoredAuthRole } from '../lib/realm'
import { useI18n } from '../i18n'
import { rememberFanvueOAuthSession } from './v2/fanvueOAuthState'
import fanltvLogo from '../assets/fanltv-logo.svg'
import '../styles/pages/login.css'

export default function Login() {
  const { t } = useI18n()
  const realm = getRealm()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [fanvueLoading, setFanvueLoading] = useState(false)
  const navigate = useNavigate()

  // Редирект если уже авторизован
  useEffect(() => {
    if (isAuthenticated(realm)) {
      navigate(defaultPathForRole(getStoredAuthRole()), { replace: true })
    }
  }, [realm, navigate])

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const result = await login(username, password, realm)
      const role = result?.role || ''
      navigate(defaultPathForRole(role), { replace: true })
    } catch (err) {
      setError(err.message || t('login.error'))
    } finally {
      setLoading(false)
    }
  }

  async function handleFanvueLogin() {
    setError('')
    setFanvueLoading(true)
    try {
      const result = await startFanvueSignupOAuth()
      const authUrl = result?.auth_url || result?.authUrl || ''
      const oauthState = result?.state || ''
      if (!authUrl || !oauthState) throw new Error('Fanvue did not return an OAuth URL.')
      rememberFanvueOAuthSession({ state: oauthState, authUrl, source: 'signup' })
      window.location.assign(authUrl)
    } catch (err) {
      setError(getApiErrorMessage(err, 'Failed to start Fanvue sign in'))
      setFanvueLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand" aria-label="FanLTV">
          <img src={fanltvLogo} alt="" aria-hidden="true" />
          <strong>FanLTV</strong>
        </div>
        <h1>{t('login.titleUser')}</h1>
        <form onSubmit={handleSubmit}>
          {error && <div className="login-error">{error}</div>}
          <label>
            {t('login.username')}
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />
          </label>
          <label>
            {t('login.password')}
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </label>
          <button type="submit" disabled={loading}>
            {loading ? t('login.submitting') : t('login.submit')}
          </button>
        </form>
        <div className="login-divider"><span>or</span></div>
        <button
          type="button"
          className="login-fanvue-button"
          disabled={fanvueLoading}
          onClick={handleFanvueLogin}
        >
          {fanvueLoading ? 'Opening Fanvue...' : 'Continue with Fanvue'}
        </button>
        <nav className="login-legal-links" aria-label="Support and legal">
          <Link to="/support">Support</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </div>
    </div>
  )
}
